export default class UserProfileService {
    isLeveragePointLogin() {
        return this.getCookie('samlConfig') === '5MYEsDPNnGDDq956/54c7A=='; 
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
}
